import React, {useContext} from 'react';
import classnames from 'classnames';

import {PathDesignContext} from 'src/components/path-design-context';
import {useMediaQuery} from 'src/hooks/useMediaQuery';

import TextButton from 'src/components/TextButton';
import Button, {Props as ButtonProps} from 'src/components/button';

export interface FooterButtonType {
  text: string;
  onClick?: () => void;
  'aria-label'?: string;
  disabled?: boolean;
  type?: ButtonProps['type'];
  width?: number | string;
  color?: ButtonProps['color'];
  buttonName?: string;
  cy?: string;
  className?: string;
  wrapper?: (
    children: React.ReactElement<{
      disabled?: boolean;
      onClick?: React.MouseEventHandler<HTMLButtonElement>;
    }>
  ) => React.ReactNode;
}

interface Props {
  buttonType: 'primary' | 'secondary' | 'tertiary';
  centered?: boolean;
}

const FooterButton = ({
  buttonType,
  type = 'button',
  text,
  color = 'blue',
  centered,
  wrapper,
  ...props
}: Props & FooterButtonType) => {
  const mq = useMediaQuery();
  const path = useContext(PathDesignContext);

  const button =
    buttonType === 'tertiary' ? (
      <TextButton
        className={classnames('shared-modal-footer-button', buttonType)}
        color={color}
        type={type}
        margin={false}
        testid={`shared-modal-footer-button-${buttonType}`}
        {...(path.enabled && {size: mq.MS_AND_DOWN ? 'small' : 'medium'})}
        {...props}
      >
        {text}
      </TextButton>
    ) : (
      <Button
        className={classnames('shared-modal-footer-button', buttonType, {centered})}
        color={color}
        outline={buttonType === 'secondary'}
        type={type}
        margin={false}
        testId={`shared-modal-footer-button-${buttonType}`}
        size={mq.MS_AND_DOWN ? 'small' : 'medium'}
        {...props}
      >
        {text}
      </Button>
    );

  return wrapper ? wrapper(button) : button;
};

export default FooterButton;
